<template>
  <div>
    <apexchart width="100%" height="170px" type="bar" :options="options" :series="series"></apexchart>
  </div>
</template>

<script>
export default {
  props: ["enviadas", "rejeitadas"],
  data: () => {
    return {
      options: {
        chart: {
          id: "envios-de-push"
        },
        xaxis: {
          categories: ["Recebidos", "Rejeitados"]
        },
        plotOptions: {
          bar: {
            horizontal: true,
            distributed: true
          }
        },
        dataLabels: {
          enabled: true
        },
        theme: {
          monochrome: {
            enabled: true,
            color: "#b22d30",
            shadeTo: "light",
            shadeIntensity: 0.5
          }
        }
      },
      series: []
    };
  },
  mounted() {
    this.series = [
      {
        data: [this.enviadas, this.rejeitadas]
      }
    ];
  }
};
</script>
